module.exports = __webpack_public_path__ + "static/media/gaming.13e7e021.svg";